import { Line } from "react-chartjs-2";
import { ChartData, ChartOptions } from "chart.js";


interface Graph {
  id: number;
  title: string;
  data: ChartData<"line">;
  options: ChartOptions<"line">;
}

interface GraphDetailProps {
  graph: Graph;
  onClose: () => void;
}

function GraphDetail({ graph, onClose }: GraphDetailProps) {
  return (
    <div style={styles.graphDetails}>
      <button style={styles.closeButton} onClick={onClose}>Close</button>
      <h2 style={styles.heading}>{graph.title}</h2>
      <Line data={graph.data} options={graph.options} />
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  graphDetails: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    backgroundColor: "white",
    padding: "30px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    maxHeight: "90vh",
  },
  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    cursor: "pointer",
  },
  heading: {
    marginTop: 0,
    marginBottom: 50,
  },
};

export default GraphDetail;
